/* eslint-disable no-unused-vars */
/* eslint-disable operator-linebreak */
import axios from 'axios';
import env from 'src/shared/env';
import { PAGE_SIZE } from './constants';

export const BOOK_KIND = {
  ebook: 'ebook',
  book: 'book',
  all: 'all',
  ebookPacket: 'ebookPacket',
};

export function getGrades() {
  return axios
    .get(`${window.getLinkHomepage()}api/Dics/Grades`)
    .then((data) => data.data);
}

export function getOlogies(gradeId) {
  return axios
    .get(`${window.getLinkHomepage()}api/Ology/Get`, {
      params: { grade: gradeId },
    })
    .then((data) => data.data);
}

export function getCurriculumns({ id, bookKind = BOOK_KIND.book }) {
  let url;
  let params = { ologyId: id };
  switch (bookKind) {
    case BOOK_KIND.ebook: {
      url = 'api/Curriculum/BelongOlogyHaveDocument';
      break;
    }
    case BOOK_KIND.book: {
      url = 'api/Curriculum/BelongOlogyHaveCopy';
      break;
    }
    case BOOK_KIND.ebookPacket: {
      url = 'api/EBookPacket/Curriculums';
      params = { packet: id };
      break;
    }
    default: {
      url = 'api/Curriculum/BelongOlogyHaveCopy';
    }
  }

  return axios
    .get(`${window.getLinkHomepage()}${url}`, {
      params,
    })
    .then((data) => data.data);
}

export function getRecordGroups() {
  return axios
    .get(`${window.getLinkHomepage()}api/Dics/RecordGroups`, {
      params: { type: 0 },
    })
    .then((data) => data.data);
}

export function getCurriculumInfo(id, bookKind) {
  const url =
    bookKind === BOOK_KIND.ebookPacket
      ? `${window.getLinkHomepage()}api/ebookpacket/PacketInfo`
      : `${window.getLinkHomepage()}api/Ology/Info`;
  const params = bookKind === BOOK_KIND.ebookPacket ? { packet: id } : { id };
  return axios
    .get(url, {
      params,
    })
    .then((data) => data.data);
}

export function getBookListByCurriculum({
  id,
  curId,
  bookType = 'ALL',
  searchValue = '',
  page = 1,
  pageSize = PAGE_SIZE,
  bookKind,
}) {
  // eslint-disable-next-line operator-linebreak
  let url;
  let params = {
    OlogyID: id,
    CurriculumID: curId,
    SearchValue: searchValue,
    StartIndex: (page - 1) * pageSize,
    BookTypeID: bookType,
    Count: pageSize,
  };

  switch (bookKind) {
    case BOOK_KIND.ebook: {
      url = 'api/ebook/SearchInOlogyByCurriculum';
      break;
    }
    case BOOK_KIND.book: {
      url = 'api/book/SearchInOlogyByCurriculumHaveCopy';
      break;
    }
    case BOOK_KIND.ebookPacket: {
      url = 'api/EBookPacket/SearchInCurriculum';
      params = {
        PacketID: id,
        CurriculumID: curId,
        Search: searchValue,
        Index: ((page - 1) * pageSize).toString(),
        Count: pageSize.toString(),
      };
      break;
    }
    default: {
      url = 'api/book/SearchInOlogyByCurriculumHaveCopy';
    }
  }

  return axios
    .post(`${window.getLinkHomepage()}${url}`, params)
    .then((data) => data.data);
}

export function getLocalBookList({
  groupId,
  searchValue = '',
  page = 1,
  pageSize = PAGE_SIZE,
  bookKind,
}) {
  const urls = {
    [BOOK_KIND.ebook]: 'api/ebook/SearchLocal',
    [BOOK_KIND.book]: 'api/book/SearchLocalHaveCopy',
    [BOOK_KIND.all]: 'api/book/SearchLocal',
  };
  const recordGroupParam =
    bookKind === BOOK_KIND.all
      ? { RecordGroupID: groupId }
      : { RecordGroupId: groupId };
  return axios
    .post(`${window.getLinkHomepage()}${urls[bookKind]}`, {
      CurriculumId: '',
      FileType: 'book',
      Count: pageSize,
      GroupType: 0,
      OlogyId: 0,
      Search: searchValue,
      StartIndex: (page - 1) * pageSize,
      ...recordGroupParam,
    })
    .then((data) => data.data);
}

export function getBooksByContent({
  searchValue = '',
  page = 1,
  pageSize = PAGE_SIZE,
}) {
  const url = `${window.getLinkHomepage()}api/ebook/SearchContent?index=${
    (page - 1) * pageSize
  }&count=${pageSize}`;

  return axios
    .post(url, {
      Content: searchValue,
    })
    .then((data) => data.data);
}